var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A57939",
    d: "M23,34c0,0-1.5-3-1-5c0.3-1.2,1.3-1.8,3-3c1.6-1.1,2-1.7,3-2c0.7-2.5,1.5-4.5,2-7 c0.2624-1.3501,0.5962-2.6853,1-4c3.1022,1.4756,6.1082,3.1456,9,5c2.3,1.5,3.5,2.4,4,4c0.6,2.1-0.5,4.1-1,5 c1.733-0.395,3.5522-0.0312,5,1c1.0498,0.6835,1.7728,1.7681,2,3c0.2183,1.4136-0.1422,2.8555-1,4c1.3967-0.0125,2.7735,0.3317,4,1 c1.3238,0.613,2.387,1.6762,3,3c0.7,1.9-0.2,4.3-2,6c1.4142-0.2318,2.8613,0.13,4,1c1.5089,1.192,2.2706,3.0962,2,5 c-0.5,3.5-4.6,4.9-5,5c-2.2,0.7-5.3,0.2-10.2-0.4c-4.4-0.6-12-0.4-18-0.4C21.3,56.3,14,54,14,51c0-2.7,2.3-4.5,3-5 c0.6347-0.3938,1.3042-0.7285,2-1c-1-2-2-3-2-4c0-1.2,1.1-3.2,3-5C22.1,33.9,23,34,23,34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A462F",
    d: "M31,13c3.1022,1.4756,6.1082,3.1456,9,5c2.3,1.5,3.5,2.4,4,4c0.6,2.1-0.5,4.1-1,5 c1.733-0.395,3.5522-0.0312,5,1c1.0498,0.6835,1.7728,1.7681,2,3c0.2183,1.4136-0.1422,2.8555-1,4c1.3967-0.0125,2.7735,0.3317,4,1 c1.3238,0.613,2.387,1.6762,3,3c0.7,1.9-0.2,4.3-2,6c1.4142-0.2318,2.8613,0.13,4,1c1.5089,1.192,2.2706,3.0962,2,5 c-0.5,3.5-4.6,4.9-5,5c-2.2,0.7-14.8-1.2-10-2c6-1,7.9-2.7,8-3c1-2-2-4-4-4c0.2-3.3-0.7-5.8-6-7c0.7-3.2-0.2-8.1-4-9 c2-4,0.4-7.2-1-10C36,17,35,15,31,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.2,
    cy: 39.4001,
    rx: 4.9,
    ry: 6.9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.6,
    cy: 38.9001,
    rx: 4.9,
    ry: 6.9,
    fill: "#FFFFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19,45 c-0.1-0.2-2.6-4.1-1-7c1.3-2.3,4.6-2.9,5-3 M43,27c0.3-0.9,1.5-3.4,1-5c-0.4-1.3-0.9-3-5-5l-8-4c0.1933,0.9907,0.1933,2.0093,0,3 c-0.2,1.1-0.7,3.3-1,5 M54,45c0.6,0.1,4.8,0.5,6,4c1,3-2,7-6,7c-4.3,0-7.5-1.2-11.7-1.6 M23.6,35.1c-0.2,0-0.4-0.1-0.6-0.1 c-0.7164-1.2072-1.064-2.5977-1-4c0.1898-2.5628,1.7074-4.8391,4-6c1.9-0.9,2.7-0.1,5-1c1.5814-0.6175,2.9644-1.6547,4-3 M48.5,35.7c0.199-0.2085,0.3673-0.4442,0.5-0.7c0.2-0.2,1.7-2.9,1-5c-1-3-6-2.9-7-3c-1.3213,1.9795-3.0205,3.6787-5,5 c-1.8714,1.2946-3.9774,2.2117-6.2,2.7 M31.3,44.7c2.9464-0.3254,5.8185-1.1364,8.5-2.4 M24.2,45h0.7 M50,35 c1.5364,0.1434,2.9634,0.8569,4,2c1.3,1.7,2.5,4.5,0,7c-2.7669,2.8203-6.2094,4.8858-10,6c-6,2-15,5-21,5c-5.1,0-9-1-9-5 c0-4.4,7.7-4.9,10.2-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2.436,
    d: "M30.9,44.6 c-0.7483,1.0288-1.9286,1.6558-3.2,1.7c-2.7,0-4.9-3.1-4.9-6.9s2.2-6.9,4.9-6.9s4.9,3.1,4.9,6.9 C32.6207,41.2731,32.0232,43.1008,30.9,44.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2.436,
    d: "M39.8,42.3 c-0.4095-1.0862-0.613-2.2392-0.6-3.4c0-3.8,2.2-6.9,4.9-6.9s4.9,3,4.9,6.9s-2.2,6.9-4.9,6.9C42.3,45.8,40.7,44.4,39.8,42.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,39c0,1.1046-0.8954,2-2,2s-2-0.8954-2-2s0.8954-2,2-2S46.1,37.8954,46.1,39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,39.4c0,1.1046-0.8954,2-2,2s-2-0.8954-2-2s0.8954-2,2-2S29.7,38.2954,29.7,39.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoop);
export default __webpack_public_path__ + "static/media/poop.09e87b9d45418b3efd6ebf63419fd63e.svg";
export { ForwardRef as ReactComponent };